import React from 'react';
import SplitFields from 'components/containers/splitFields/splitFields';
import { Errors } from 'react-redux-form';
import { formatText } from 'core/i18n';
import StringHelper from 'utilities/stringHelper';
import { BirthDay } from './BirthDay/BirthDay';
import { BirthMonth } from './BirthMonth/BirthMonth';
import { BirthYear } from './BirthYear/BirthYear';

const handleCursor = event => {
    const iLength = 2;
    const val = event.target.value;
    const name = event.target.name;

    if (val.length >= iLength) {
        const birthMonth = document.getElementById('birthMonth');
        const birthYear = document.getElementById('birthYear');

        switch (name) {
            case 'birthDay':
                birthMonth.focus();
                break;
            case 'birthMonth':
                birthYear.focus();
                break;
            default:
                break;
        }
    }
};

const renderErrors = props => {
    return <p className="form__field_error">{props.children}</p>;
};
export const BirthDate = ({
    userProfile,
    userProfileForm,
    formActions,
    isValidDate,
    isBirthDateGroupValidate,
    validateGroups,
    onFocusBirthDay,
    onFocusBirthMonth,
    onFocusBirthYear,
    onFocus,
    onBlur,
    hideTextErrors,
}) => {
    const birthdateText = StringHelper.concatString(
        [userProfile.birthDay, userProfile.birthMonth, userProfile.birthYear],
        '/'
    );

    const BIRTH_DATE_FIELDS = { day: 'birthDay', month: 'birthMonth', year: 'birthYear' };
    const birthDateHasFocus = () => Object.values(BIRTH_DATE_FIELDS).includes(document.activeElement.id);

    const handleOnFocus = callback => {
        if (birthDateHasFocus()) {
            onFocus?.();
        }

        callback?.();
    };

    const handleOnBlur = () => {
        if (!birthDateHasFocus()) {
            onBlur?.();
        }
    };

    return (
        <SplitFields
            placeholder={formatText('field-birthdate')}
            text={birthdateText}
            inputFocus={BIRTH_DATE_FIELDS.day}
            isValid={isBirthDateGroupValidate && isValidDate}
            classCol="col-sm-6"
        >
            <div className="row form__group-inputs">
                <div className={!isValidDate && !birthDateHasFocus() ? 'form__group-inputs--error' : undefined}>
                    <div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="row">
                                <BirthDay
                                    userProfile={userProfile}
                                    userProfileForm={userProfileForm}
                                    formActions={formActions}
                                    handleCursor={handleCursor}
                                    validateGroups={validateGroups}
                                    onFocus={() => handleOnFocus(onFocusBirthDay)}
                                    onBlur={handleOnBlur}
                                />
                                <BirthMonth
                                    userProfile={userProfile}
                                    userProfileForm={userProfileForm}
                                    formActions={formActions}
                                    handleCursor={handleCursor}
                                    validateGroups={validateGroups}
                                    onFocus={() => handleOnFocus(onFocusBirthMonth)}
                                    onBlur={handleOnBlur}
                                />
                                <BirthYear
                                    userProfile={userProfile}
                                    userProfileForm={userProfileForm}
                                    formActions={formActions}
                                    validateGroups={validateGroups}
                                    onFocus={() => handleOnFocus(onFocusBirthYear)}
                                    onBlur={handleOnBlur}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Errors
                show={!hideTextErrors}
                model="userProfile.birthDate"
                messages={{
                    valid: formatText('validation-birthDate'),
                    older: '',
                    required: formatText('validation-fieldRequired'),
                    validYearLength: formatText('validation-birthdayLength'),
                    validPinBirthDate: formatText('validation-birthdayMatchesPassword'),
                }}
                component={renderErrors}
            />
        </SplitFields>
    );
};
